exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".CompetitionBestTodayWidget,.CompetitionCriteriasWidget,.CompetitionGoalWidget,.CompetitionTimeLeftWidget{position:absolute;top:0;left:0;right:0;bottom:0;box-sizing:border-box;padding:15px}.CompetitionBestTodayWidget,.CompetitionGoalWidget,.CompetitionTimeLeftWidget{background-color:#fff}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?outputStyle=expanded!./client/components/Widgets/CompetitionWidgets/CompetitionWidgets.scss
 ** module id = 772
 ** module chunks = 0
 **/